import { cachedRequest } from '../../lib/request';

export const resolveDiscountGtin = code =>
  cachedRequest('/DiscountCodeMap?code=' + code);
